import styled from 'styled-components';

export const FootballFixtures = styled.div`
  background: transparent;
  position: relative;
  width: 100%;
  font: var(--font-body-m);

  .mtm {
    margin-top: var(--space-400);
  }
  .mbm {
    margin-bottom: var(--space-400);
  }
  span.error {
    font-size: 12px;
    color: var(--color-salmon-500);
  }
`;

export const FixtureTable = styled.table`
  margin: 0;
  width: 100%;
  background: var(--color-background-surface-primary);
  color: var(--color-text);
  overflow: hidden;
  /* Resetting user agent styles */
  border-collapse: collapse;
  border-spacing: 0;

  /* Mobile only */
  @media (max-width: 767px) {
    border-collapse: separate;
    background: var(--color-light-sand);
    .list,
    .fixture-view,
    .no-fixtures {
      display: block;
      margin-bottom: var(--space-300);
    }

    .expanded {
      margin-bottom: 0;
    }

    .list td {
      display: block;
      border-top: 1px solid var(--color-border-primary);
      border-right: 1px solid var(--color-grey-100);
      border-left: 1px solid var(--color-grey-100);
      margin-bottom: 0;
      margin-top: 0;
      &:first-of-type {
        border-right: 0;
      }
      &:nth-of-type(-n + 2) {
        display: table-cell;
        border-top: 1px solid var(--color-grey-100);
      }
      &:nth-of-type(2) {
        width: 100%;
        border-left: 0;
        padding-left: var(--space-300);
      }
      &:last-of-type {
        border-bottom: 1px solid var(--color-grey-100);
        border-radius: 0 0 var(--border-radius-500) var(--border-radius-500);
      }
      &:first-child {
        border-top: 1px solid var(--color-grey-100);
        border-radius: var(--border-radius-500) 0 0 0;
      }
      &:nth-of-type(2) {
        border-top: 1px solid var(--color-grey-100);
        border-radius: 0 var(--border-radius-500) 0 0;
      }
    }

    .expanded td:last-of-type {
      border-bottom: none;
      border-radius: 0;
    }

    .no-fixtures td,
    .fixture-view td {
      display: block;
      overflow: hidden;
      background-color: var(--color-white);
      border: 1px solid var(--color-grey-100);
      border-radius: var(--border-radius-500);
    }
    .no-fixtures td > div {
      padding: var(--space-400) var(--space-500);
    }
    .fixture-view td {
      border-radius: 0 0 var(--border-radius-500) var(--border-radius-500);
      border-top-color: var(--color-border-primary);
    }
  }

  /* Desktop only */
  @media (min-width: 768px) {
    box-shadow: var(--elevation-100);
    border-radius: var(--border-radius-500);

    tr {
      &:first-of-type td {
        border-width: 2px;
      }
      &:last-of-type td {
        padding-bottom: var(--space-700);
      }
    }

    th,
    .list td {
      background: none;
      padding-left: var(--space-300);
      padding-right: var(--space-300);
      &:first-of-type {
        padding-left: var(--space-500);
        width: 156px;
        min-width: 156px;
      }
      &:nth-last-of-type(-n + 2) {
        width: 150px;
        min-width: 150px;
      }
      &:last-of-type {
        padding-right: var(--space-500);
      }
    }

    .no-fixtures td {
      width: 100%;
      padding: var(--space-400) var(--space-500);
    }

    .list td,
    .no-fixtures td {
      border-top: 1px solid var(--color-border-primary);
      &:before {
        display: none;
      }
    }
  }
`;
